import { tailwindColors } from '@repo/tailwind-config/tailwind.vars'
import { DateFormatter } from '@repo/toolkit/date'
import { SVGFC } from '@repo/toolkit/types'
import { CheckMark3Icon, PendingIcon, XIcon } from '@repo/ui/icons'

import { StatusOption } from '../../utils'

export enum MedicalStatusEnum {
  RAS = 'RAS',
  CHECK_LEVEL_0 = 'CHECK_LEVEL_0',
  DECLARATION_PENDING = 'DECLARATION_PENDING',
  DECLARATION_SIGNED = 'DECLARATION_SIGNED',
  DECLARATION_REJECTED = 'DECLARATION_REJECTED',
  PENDING_LEC_MASTER_VALIDATION = 'PENDING_LEC_MASTER_VALIDATION',
  ATTESTATION_PENDING = 'ATTESTATION_PENDING',
  ATTESTATION_SIGNED = 'ATTESTATION_SIGNED',
  VALIDATED_BY_LEC = 'VALIDATED_BY_LEC'
}

export const medicalStatusEnumMapping: Record<
  MedicalStatusEnum,
  StatusOption & { action?: (date: Date) => string; icon?: SVGFC }
> = {
  [MedicalStatusEnum.RAS]: { label: 'RAS', variant: 'success' },
  [MedicalStatusEnum.CHECK_LEVEL_0]: { label: 'Vérification requise', variant: 'warning' },
  [MedicalStatusEnum.DECLARATION_PENDING]: {
    label: 'Déclaration en attente du client',
    variant: 'danger',
    action: (date) => `Déclaration en attente du client depuis le ${DateFormatter.DDMMYYYY(date)}`,
    icon: () => <PendingIcon color={tailwindColors.red.DEFAULT} />
  },
  [MedicalStatusEnum.DECLARATION_SIGNED]: {
    label: 'Déclaration signée',
    variant: 'warning',
    action: (date) => `Déclaration signée le ${DateFormatter.DDMMYYYY(date)}`,
    icon: () => <CheckMark3Icon color={tailwindColors.green.DEFAULT} />
  },
  [MedicalStatusEnum.DECLARATION_REJECTED]: {
    label: 'Déclaration rejetée',
    variant: 'warning',
    action: (date) => `Déclaration rejetée le ${DateFormatter.DDMMYYYY(date)}`,
    icon: () => <XIcon color={tailwindColors.red.DEFAULT} />
  },
  [MedicalStatusEnum.PENDING_LEC_MASTER_VALIDATION]: {
    label: 'En attente de validation par admin LEC',
    variant: 'warning',
    action: (date) => `En attente de validation par LEC depuis le ${DateFormatter.DDMMYYYY(date)}`,
    icon: () => <PendingIcon color={tailwindColors.secondary.DEFAULT} />
  },
  [MedicalStatusEnum.ATTESTATION_PENDING]: {
    label: 'Attestation en attente du client',
    variant: 'danger',
    action: (date) => `Attestation en attente du client depuis le ${DateFormatter.DDMMYYYY(date)}`,
    icon: () => <PendingIcon color={tailwindColors.red.DEFAULT} />
  },
  [MedicalStatusEnum.ATTESTATION_SIGNED]: {
    label: 'Attestation signée',
    variant: 'success',
    action: (date) => `Attestation signée le ${DateFormatter.DDMMYYYY(date)}`,
    icon: () => <CheckMark3Icon color={tailwindColors.green.DEFAULT} />
  },
  [MedicalStatusEnum.VALIDATED_BY_LEC]: {
    label: 'Validé par LEC',
    variant: 'success',
    action: (date) => `Validé par LEC le ${DateFormatter.DDMMYYYY(date)}`,
    icon: () => <CheckMark3Icon color={tailwindColors.green.DEFAULT} />
  }
}
